import { render, staticRenderFns } from "./campaign-details.vue?vue&type=template&id=0e0a23c4&scoped=true"
import script from "./campaign-details.vue?vue&type=script&lang=js"
export * from "./campaign-details.vue?vue&type=script&lang=js"
import style0 from "./campaign-details.vue?vue&type=style&index=0&id=0e0a23c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a23c4",
  null
  
)

export default component.exports